import type { ComponentPropsWithoutRef, ElementType, ReactNode } from "react";

import { cx } from "@tripcart/traveler-ui/cx";

import styles from "./chrome-container.module.css";

/**
 * The CSS Modules sibling of `Container` (`container.tsx`) for the storefront
 * chrome (header/footer). Same width + gutter contract as `SITE_CONTAINER` —
 * 1280px, with 16px gutters under 768px and 32px at/above it.
 */
type ChromeContainerProps<T extends ElementType> = {
  as?: T;
  className?: string;
  children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, "as" | "className" | "children">;

export function ChromeContainer<T extends ElementType = "div">({
  as,
  className,
  children,
  ...props
}: ChromeContainerProps<T>) {
  const Comp = (as ?? "div") as ElementType;
  return (
    <Comp className={cx(styles.container, className)} {...props}>
      {children}
    </Comp>
  );
}
